import { isChrome, isFirefox, isIOS, isOpera } from 'react-device-detect'
import type { ShopSessionSigningStatus } from '@/services/graphql/generated'
import { logger } from '@/services/logger/logger.client'
import { BankIdState } from './bankId.types'

const stateMapping = {
  // That status is used in ShopSessionSigningStatus when signig after a login (unauthenticated returning member)
  CREATING: BankIdState.Success, // ShopSessionSigningStatus only
  PENDING: BankIdState.Pending,
  COMPLETED: BankIdState.Success, // Auth API only
  SIGNED: BankIdState.Success, // ShopSessionSigningStatus only
  FAILED: BankIdState.Error,
}

export const apiStatusToBankIdState = (apiState: keyof typeof stateMapping | ShopSessionSigningStatus) =>
  stateMapping[apiState]

export const bankIdLogger = logger.createLogger({ name: 'bankId' })

export function getBankIdUrl(autoStartToken: string) {
  // https://www.bankid.com/en/utvecklare/guider/teknisk-integrationsguide/programstart
  const bankidUrl = new URL('bankid:///')
  bankidUrl.searchParams.append('autostarttoken', autoStartToken)
  bankidUrl.searchParams.append('redirect', getReturnURL())

  return bankidUrl.toString()
}

function getReturnURL() {
  // For IOS 'redirect' must have a value.
  if (isIOS) {
    if (isChrome) return 'googlechrome://'
    if (isFirefox) return 'firefox://'
    if (isOpera) return 'opera://'
    // For Safari or other browsers we return 'null' as well, even though there will be no redirect
    // for such cases. Instead user will have to manually go back to the app.
  }

  // In most cases 'null' means the BankID app will redirect back to the calling app.
  // It's recommended to set redirect to null when possible.
  return 'null'
}
